<template>
  <div>
    <video class="hero" src="https://firebasestorage.googleapis.com/v0/b/hydro-ottawa-ai.appspot.com/o/robot-story.mp4?alt=media&token=d5f5c160-f3d5-46cb-993d-64fa6719fe97" autoplay muted loop></video>
  </div>
</template>
<script>
export default ({
  name: 'Dashboard',
  data() {
    return {
      // 
    }
  }
})
</script>
<style lang="scss">
  .hero {
    // position: relative;
    // img, video {
    //   width: 100%;
    //   display: block;
    // }
    display: block;
    width: 100%;
  }
</style>